import {constant, emptyArray} from '@packages/utilities/fp/utils';
import {None, type NoneT} from './option';

type EmptyDynamoEnv = {
  [prop: string]: NoneT;
};

const emptyDynamoEnvTarget: EmptyDynamoEnv = {};

export const EMPTY_DYNAMO_ENV: EmptyDynamoEnv = new Proxy<EmptyDynamoEnv>(
  emptyDynamoEnvTarget,
  {
    get: constant(None),
    has: constant(true),
    getOwnPropertyDescriptor: constant({
      value: None,
      writable: false,
      configurable: true,
      enumerable: false,
    }),
    ownKeys: constant(emptyArray),
  }
);
